import { digObject } from 'functions/utilities'

export default function getSortedKeys(dataSource, components){
  const sortedSectionKeys = digObject(dataSource, 'options.sorted_section_keys', [])

  const unsortedComponentKeys = components
    .filter(component => !sortedSectionKeys.includes(component.key))
    .map(component => component.key)

  if (unsortedComponentKeys.length === components.length){
    return components.map(component => component.key)
  }

  if (dataSource && sortedSectionKeys){
    const keyCountsMatch = components.length === sortedSectionKeys.length
    if (keyCountsMatch && !unsortedComponentKeys.length) return sortedSectionKeys
  }

  if (sortedSectionKeys.length && unsortedComponentKeys.length){
    return [...sortedSectionKeys, ...unsortedComponentKeys]
  }

  return components.map(component => component.key)
}
